import { useEffect, useState } from 'react'

import { TimerRow, TimerBadge, CountdownText, RefreshButton } from './CountdownTimer.styles'

const RefreshIcon = ({
  color = '#3452FF'
}: {
  color?: string
}) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5125 2.15417C11.1833 0.825 9.35917 0 7.33333 0C5.38841 0 3.52315 0.772617 2.14788 2.14788C0.772617 3.52315 0 5.38841 0 7.33333C0 9.27825 0.772617 11.1435 2.14788 12.5188C3.52315 13.8941 5.38841 14.6667 7.33333 14.6667C10.7525 14.6667 13.6033 12.3292 14.4192 9.16667H12.5125C11.7608 11.3025 9.72583 12.8333 7.33333 12.8333C5.87464 12.8333 4.4757 12.2539 3.44425 11.2224C2.4128 10.191 1.83333 8.79202 1.83333 7.33333C1.83333 5.87464 2.4128 4.4757 3.44425 3.44425C4.4757 2.4128 5.87464 1.83333 7.33333 1.83333C8.855 1.83333 10.2117 2.46583 11.2017 3.465L8.25 6.41667H14.6667V0L12.5125 2.15417Z" fill={color} />
    </svg>
  )
}

const TimerIcon = ({
  color = '#868E96'
}: {
  color?: string
}) => {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H7V3.5L4.66667 5.83333L7 8.16667V11.6667H0V8.16667L2.33333 5.83333L0 3.5V0ZM5.83333 8.45833L3.5 6.125L1.16667 8.45833V10.5H5.83333V8.45833ZM3.5 5.54167L5.83333 3.20833V1.16667H1.16667V3.20833L3.5 5.54167ZM2.33333 2.33333H4.66667V2.77083L3.5 3.9375L2.33333 2.77083V2.33333Z" fill={color} />
    </svg>
  )
}

export interface CountdownTimerProps {
  validTime: number
  onRefresh?: () => void
  isRefreshing?: boolean
  showRefreshButton?: boolean
}

export default function CountdownTimer({
  validTime,
  onRefresh,
  isRefreshing = false,
  showRefreshButton = true,
}: CountdownTimerProps) {
  const [countdown, setCountdown] = useState('')
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    if (!validTime) return

    const updateCountdown = () => {
      const now = Math.floor(Date.now() / 1000)
      const remainingSeconds = validTime - now

      if (remainingSeconds <= 0) {
        setCountdown('00:00')
        setIsExpired(true)
        return
      }

      setIsExpired(false)
      const minutes = Math.floor(remainingSeconds / 60)
      const seconds = remainingSeconds % 60
      setCountdown(
        `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      )
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [validTime])

  const handleRefresh = () => {
    if (onRefresh && !isRefreshing && isExpired) {
      onRefresh()
    }
  }

  return (
    <TimerRow>
      {showRefreshButton && isExpired && (
        <RefreshButton
          type="button"
          onClick={handleRefresh}
          disabled={isRefreshing}
          style={{ opacity: isRefreshing ? 0.5 : 1 }}
          aria-label="Refresh exchange rate"
        >
          <RefreshIcon />
        </RefreshButton>
      )}
      <TimerBadge>
        <TimerIcon />
        <CountdownText>{countdown || '00:00'}</CountdownText>
      </TimerBadge>
    </TimerRow>
  )
}
